export const scoreBadgeBackgroundColor = (score: number, decorateZero: boolean = true) => {
    switch (true) {
        case decorateZero && score === 0: return "bg-gray-50";
        case score < 1000: return "bg-yellow-50";
        case score < 2500: return "bg-lime-50";
        case score < 4000: return "bg-green-light-50";
        default: return "bg-success-50";
    }
};

export const scoreBarColor = (score: number, decorateZero: boolean = true) => {
    switch (true) {
        case decorateZero && score === 0: return "bg-gray-400";
        case score < 1000: return "bg-yellow-300";
        case score < 2500: return "bg-lime-300";
        case score < 4000: return "bg-green-light-300";
        default: return "bg-success-300";
    }
};

export const scoreEncouragement = (score: number, decorateZero: boolean = true) => {
    switch (true) {
        case decorateZero && score === 0: return "None";
        case score < 1000: return "Keep Going ";
        case score < 2500: return "Good";
        case score < 4000: return "Great";
        default: return "Excellent";
    }
};

export const scoreTextColor = (score: number, decorateZero: boolean = true) => {
    switch (true) {
        case decorateZero && score === 0: return "text-gray-700";
        case score < 1000: return "text-yellow-700";
        case score < 2500: return "text-lime-800";
        case score < 4000: return "text-green-light-700";
        default: return "text-success-700";
    }
};

export const scoreTooltip = (score: number) => {
    switch (true) {
        case score < 1000: return "0-999";
        case score < 2500: return "1000-2499";
        case score < 4000: return "2500-3999";
        default: return "4000-5000+";
    }
};